import React from "react";
import { LeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Messages } from "./Messages";
import { Col, Row } from "antd";

const Header = ({
  children,
  content,
  link,
  tall = false,
  right,
  left,
  isOpen,
  messages = false,
  ...props
}) => {
  return (
    <div id="site-header" {...props}>
      <div
        className={`wrapper-content ${tall ? "tall" : ""} ${
          isOpen ? "active" : ""
        }`}
      >
        <div className="top-content">
          <Row>
            <Col span={2}>
              <div className="right-button-header">
                {messages ? <Messages /> : right ? right : ""}
              </div>
            </Col>

            <Col span={20}>
              <div className="center-part-header">{content}</div>
            </Col>

            <Col span={2}>
              <div className="left-button-header">
                {left ? (
                  left
                ) : link ? (
                  <Link to={link}>
                    <LeftOutlined className="back-icon" />
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
        </div>
        {children && children}
      </div>
    </div>
  );
};

export default Header;
